import axios from 'axios';
import moment from 'moment';
import { errorHandler } from "./libs/lib.js";

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','tgl1','tgl2','pjxkey','pjxName']
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/transactiontracker${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.sumKeys = meta.sumKeys || [];
                obj.sumKeys.map(async key => {
                    obj[key]=meta[key];
                });
                
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getLastReconDate(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pjxkey']
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/transactiontracker/getlast-recon${str}`;
                const {data} = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    transactiontrackerupload(file, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('filename', file.name);
                const keys = ['tgl1', 'tgl2','pjxkey'];
                for (const key in obj) {
                    formData.append(key, obj[key]);
                }
                const { data } = await axios.post(`/transactiontracker/transaction-tracker-upload`, formData);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reconTracker(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`/transactiontracker/transaction-tracker-reconcile`,obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reconRecheck(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('obj',obj)
                await axios.post(`/transactiontracker/transaction-tracker-recheck`,obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir','tgl1','tgl2','tblFields','pjxkey','pjxName']
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/transactiontracker/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `tracker_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
    
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
}